import { ComponentRef, ViewContainerRef } from '@angular/core';

import { ExperienceFinderAiComponent } from '@hiptraveler/features/experience-finder';

export type ExpFinderPanelAction = ExpFinderPanelActionService | null;

export function expFinderPanelAction(): ExpFinderPanelActionService {
  return new ExpFinderPanelActionService();
}

export class ExpFinderPanelActionService {

  private panelRef: ComponentRef<ExperienceFinderAiComponent> | null;
  private panelLoaded: boolean = false;

  async openExperienceFinderPanel(container: ViewContainerRef, options?: {
    action?: string, desktop?: boolean
  }): Promise<void> {

    if (this.panelLoaded) {
      console.warn('Experience Finder panel is already open. Skipping duplicate initialization.');
      return;
    }

    this.panelLoaded = true;

    try {
      container.clear();
      await import('./host/experience-finder-ai.module');
      const resolver = await import('./host/experience-finder-ai.component');
      this.panelRef = container.createComponent(resolver.ExperienceFinderAiComponent);
      this.panelRef.instance.action = options?.action || 'menu';
      this.panelRef.instance.desktop = !!options?.desktop;
      this.panelRef.instance.ref = this.panelRef;
    } catch (e) { }
  }

  closeExperienceFinder(): void {

    if (!this.panelRef) return;

    this.panelRef.destroy();
    this.panelRef = null;
    this.panelLoaded = false;
  }

}
